import 'nestedSortable';

/**
 * Initialize
 *
 * @param  {jQuery} el
 */
export function init (el) {
  $(el).nestedSortable({
    handle: '.handle',
    items: '.list-group-item',
    toleranceElement: '> .list-group-item-container',
    listType: 'div',
    update: _sortCategories
  });
}

/**
 * Sort categories.
 *
 * @param  {Event} event
 * @param  {object} ui
 */
function _sortCategories(event, ui) {
  $.ajax({
    url: '/categories/hierarchy',
    method: 'POST',
    data: {
      store_id: ui.item.closest('.is-root').attr('id'),
      nodes: $(this).nestedSortable('toHierarchy')
    }
  });
}
